import React, { useEffect, useState } from "react";
import AppStorage from "easy-app-storage";
import { QueryClient, QueryClientProvider } from "react-query";
import Theme from "../../configs/theme";

import {
    MultiProvider,
    ApiProvider,
    storageOptions,
    I18nProvider,
    StorageProvider,
    api,
    SpringBigThemeProvider,
    SpringBigStoreProvider,
    AppSettingsProvider,
    StashboardProvider,
    ThemeOverrides,
    ClientType,
    CONFIG_URL
} from "@springbig/shared";

import AppRoutes from "./routes";
import SplashScreen from "./shared/SplashScreen/SplashScreen";

const appStorage = new AppStorage(localStorage, storageOptions);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 0
        }
    }
});

const App = () => {

    const [settings, setSettings] = useState<any>();
    const [languageEdit, setLanguageEdit] = useState();
    const [language, setLanguage] = useState();
    const [client, setClient] = useState<ClientType>();
    const [theme, setTheme] = useState<ThemeOverrides>();
    const [isConfigsLoading, setIsConfigLoading] = useState<boolean>(false);

    useEffect(() => {


        const fetchData = async () => {
            try {
                const response = await fetch(process.env.PUBLIC_URL + '/static/data.json');
                const data = await response.json();
                setClient(data.clientName)
            } catch (error) {
                setClient('springbigQA')
                console.error('Error fetching JSON data:', error);
            }
        };

        fetchData();
    }, []);

    const loadJsonData = async () => {

        try {

            if (client) {
                const BASE_URL = `${CONFIG_URL}/${client.toLowerCase()}`;

                setIsConfigLoading(true);
                const _settings = await fetch(`${BASE_URL}/configs/settings.json`, { mode: 'cors' });
                const _theme = await fetch(`${BASE_URL}/configs/colors.json`, { mode: 'cors' });
                const _language = await fetch(`${BASE_URL}/configs/language.json`, { mode: 'cors' });
                const _languageEdit = await fetch(`${BASE_URL}/configs/languageEdit.json`, { mode: 'cors' });

                const themeJson = await _theme.json();
                const settingsJson = await _settings.json();
                const languageJson = await _language.json();
                const languageEditJson = await _languageEdit.json();


                setIsConfigLoading(false);

                setTheme(Theme(themeJson.dark, themeJson.light, themeJson.colors));
                setSettings(settingsJson);
                setLanguageEdit(languageEditJson as any);
                setLanguage(languageJson as any);
            }
        } catch (error) {
            console.error('Error loading JSON:', error, client);
        }
    };

    useEffect(() => {

        loadJsonData();
    }, [client]);

    const updateMerchant = (client: ClientType) => {

        setClient(client);
    }

    if (isConfigsLoading) {
        return <SplashScreen />
    }


    return (
        <MultiProvider
            providers={[
                <QueryClientProvider client={queryClient} />,
                <StorageProvider storage={appStorage} />,
                <SpringBigStoreProvider queryClient={queryClient} />,
                <ApiProvider api={api} />,
                <SpringBigThemeProvider themeConfig={theme} />,
                <I18nProvider language={language || {}} languagesEdit={languageEdit} />,
                <AppSettingsProvider {...settings} />,
                <StashboardProvider />,
            ]}
        >
            <AppRoutes updateMerchant={updateMerchant} />
        </MultiProvider>
    );
}

export default App;
// export default Config;
